import { Box } from "@mui/material";
import { useMemo } from "react";
import NetworkTable from "../../../componentes/newEasyAdd/table";

const IP_REGEX =
  /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$|^(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}$/i;

const ipValidator = (value, callback) => {
  if (!value) {
    callback(true);
    return;
  }
  callback(IP_REGEX.test(value));
};

export default function CadastroTable(props) {
  const {
    hostsCadastrados,
    templates,
    setOpenEditHostModal,
    setEditingHostDescriptionModal,
    setEditingHostData,
    handleRequestDelete,
    proxys = [],
    buscarHost,
    proxyFilter,
    fabricanteFilter,
    modeloFilter,
    statusPingFilter,
    statusSnmpFilter,
    loadingTable,
    loading,
  } = props;

  // Mapeamento de Proxys
  const { proxyNames, proxyMap } = useMemo(() => {
    const names = ["Sem Proxy"];
    const map = { 0: "Sem Proxy" };

    if (Array.isArray(proxys)) {
      proxys.forEach((p) => {
        names.push(p.host);
        map[p.proxyid] = p.host;
      });
    }
    return { proxyNames: names, proxyMap: map };
  }, [proxys]);

  // --- LÓGICA DE FILTRO E PREPARAÇÃO DOS DADOS ---
  const rowsForDisplay = useMemo(() => {
    // 1. Primeiro mapeamos os dados para o formato de exibição (ex: resolvendo nome do Proxy)
    const mappedRows = hostsCadastrados?.map((host) => {
      const proxyId = host.proxy || "0";
      const proxyDisplayName =
        proxyMap[proxyId] || (proxyId === "0" ? "Sem Proxy" : proxyId);

      return {
        ...host,
        proxy: proxyDisplayName,
        checks: {
          ping:
            host?.checks?.ping === true
              ? "Ativo"
              : host?.checks?.ping === false
                ? "Inativo"
                : null,
          snmp:
            host?.checks?.snmp === true
              ? "Ativo"
              : host?.checks?.snmp === false
                ? "Inativo"
                : null,
        },
      };
    });

    let filtered = mappedRows;

    if (buscarHost) {
      const searchLower = buscarHost.toLowerCase();
      const check = (val) =>
        val && String(val).toLowerCase().includes(searchLower);

      filtered = filtered.filter(
        (row) =>
          check(row.id) ||
          check(row.hostid) ||
          check(row.nome) ||
          check(row.ip) ||
          check(row.comunidade) ||
          check(row.portaSnmp) ||
          check(row.fabricante) ||
          check(row.modelo) ||
          check(row.userSsh) ||
          check(row.senhaSsh) ||
          check(row.portaSsh) ||
          check(row.proxy),
      );
    }

    if (proxyFilter) {
      filtered = filtered.filter((row) => row.proxy === proxyFilter);
    }

    if (fabricanteFilter) {
      filtered = filtered.filter(
        (row) =>
          row.fabricante.toLowerCase() === fabricanteFilter.toLowerCase(),
      );
    }
    if (modeloFilter) {
      filtered = filtered.filter(
        (row) => row.modelo.toLowerCase() === modeloFilter.toLowerCase(),
      );
    }
    if (statusPingFilter) {
      filtered = filtered.filter((row) => row.checks.ping === false);
    }
    if (statusSnmpFilter) {
      filtered = filtered.filter((row) => row.checks.snmp === false);
    }

    return filtered;
  }, [
    hostsCadastrados,
    proxyMap,
    buscarHost,
    proxyFilter,
    fabricanteFilter,
    modeloFilter,
    statusPingFilter,
    statusSnmpFilter,
  ]);

  const { manufacturerList, equipmentMap } = useMemo(() => {
    const map = {};
    const list = [];
    if (Array.isArray(templates)) {
      templates.forEach((item) => {
        const key = item?.fabricante;
        if (key) {
          list.push(key);
          map[key] = item?.Funcoes.flatMap((f) =>
            f.Modelos.map((m) => `${f.funcao} - ${m.modelo}`),
          );
        }
      });
    }
    return { manufacturerList: list, equipmentMap: map };
  }, [templates]);

  const tableColumns = useMemo(() => {
    const cols = [
      { data: "nome", type: "text", width: 130 },
      { data: "ip", validator: ipValidator, width: 95 },
      {
        data: "checks.ping",
        readOnly: true,
        focusable: false,
        width: 70,
      },
      {
        data: "checks.snmp",
        readOnly: true,
        focusable: false,
        width: 70,
      },
      { data: "comunidade", type: "text", width: 100 },
      { data: "portaSnmp", type: "text", width: 80 },
      {
        data: "fabricante",
        type: "dropdown",
        source: manufacturerList,
        width: 130,
      },
      { data: "modelo", type: "dropdown", source: [], width: 130 },
      { data: "userSsh", type: "text", width: 100 },
      { data: "senhaSsh", type: "text", width: 80 },
      { data: "portaSsh", type: "text", width: 100 },
      { data: "proxy", type: "dropdown", source: proxyNames, width: 100 },
    ];

    cols.push({
      data: "actions",
      readOnly: true,
      focusable: false,
      width: 80,
      className: "htCenter",
    });

    return cols;
  }, [manufacturerList, proxyNames]);

  const handleEditRow = (rowData) => {
    setEditingHostData(rowData);
    setOpenEditHostModal(true);
  };

  const handleDeleteRow = (rowData) => {
    const idToDelete = rowData.id || rowData.hostid || rowData.hostId;
    handleRequestDelete(idToDelete);
  };

  const handleEditDescriptionRow = (rowData) => {
    setEditingHostData(rowData);
    setEditingHostDescriptionModal(true);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <NetworkTable
        rows={rowsForDisplay}
        columns={tableColumns}
        equipmentMap={equipmentMap}
        onEditRow={handleEditRow}
        onDeleteRow={handleDeleteRow}
        onEditDescriptionRow={handleEditDescriptionRow}
        loadingTable={loadingTable}
        loading={loading}
        hosts={hostsCadastrados}
      />
    </Box>
  );
}
